<template>
  <router-view module="sales"></router-view>
</template>

<script>
export default {
  name: "DealSales"
};
</script>
